import React, { Component, Fragment } from 'react';
import '../../../config/cssDTB/buttonsDTB.css';
import ConfDtb from '../../../config/confDtb';
import swal from 'sweetalert';
import { dataProdi } from '../../../dummy-data/prodi';
import { dropdownAngkatan, dropdownJalur, dataMahasiswa } from '../../../dummy-data/mahasiswa';

const $ = require("jquery");
$.Datatable = require("datatables.net");

class GeneratePass extends Component {

    state = {
        check_list: [],
        listMahasiswa: [],
        listProdi: [],
        listAngkatan: [],
        listJalur: [],
        prodi: '',
        thn_angkatan: '',
        jalur: '',
        statusData: ''
    }

    // get data prodi for select prodi
    getProdi = () => {
        this.setState({
            listProdi: dataProdi.map(p => ({ ijur: p.prodi_id, nmjur: p.prodi_nama }))
        });
        setTimeout(() => {
            if (document.getElementById("prodi") != null) {
                document.getElementById("prodi").disabled = false;
            }
            if (document.getElementById("loaderProdi") != null) {
                document.getElementById("loaderProdi").classList.add("sembunyi");
            }
        }, 200);
    }

    // get data angkatan for select angkatan
    getAngkatan = () => {
        this.setState({
            listAngkatan: dropdownAngkatan.map(a => ({ idtj: a.value, ketj: a.label }))
        });
        setTimeout(() => {
            if (document.getElementById("angkatan") != null) {
                document.getElementById("angkatan").disabled = false;
            }
            if (document.getElementById("loaderAngkatan") != null) {
                document.getElementById("loaderAngkatan").classList.add("sembunyi");
            }
        }, 200);
    }

    // get data jalur for select jalur
    getJalur = () => {
        this.setState({
            listJalur: dropdownJalur.map(j => ({ idjl: j.value, nmjl: j.label }))
        });
        setTimeout(() => {
            if (document.getElementById("jalur") != null) {
                document.getElementById("jalur").disabled = false;
            }
            if (document.getElementById("loaderJalur") != null) {
                document.getElementById("loaderJalur").classList.add("sembunyi");
            }
        }, 200);
    }

    // handle untuk perubahan value input by name
    InputChange = (event) => {
        event.preventDefault();
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    toggleCheckboxAll = (event) => {
        let checkboxes = document.getElementsByName('check_list');
        if (event.target.checked) {
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = true;
                this.state.check_list[i] = checkboxes[i].value;
            }
        } else {
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
                this.state.check_list = []
            }
        }

    }
    toggleCheckbox = (event) => {
        if (event.target.checked) {
            this.state.check_list.push(event.target.value)
        } else {
            var index = this.state.check_list.indexOf(event.target.value);
            this.state.check_list.splice(index, 1);
        }

    }

    // cari mahasiswa
    SearchMahasiswaClick = (event) => {
        event.preventDefault();
        this.SearchMahasiswa();
    }
    SearchMahasiswa = () => {
        $('#genPass').DataTable().destroy();
        var btn = document.getElementById("btn-cari");
        btn.disabled = true;
        document.getElementById("loader").style.display = "block";
        document.getElementById("kontenTabel").style.display = "none";

        // Filter mahasiswa using dummy data
        let filtered = [...dataMahasiswa];

        if (this.state.prodi) {
            filtered = filtered.filter(m => m.prodi_id === parseInt(this.state.prodi));
        }
        if (this.state.thn_angkatan) {
            filtered = filtered.filter(m => m.angkatan === parseInt(this.state.thn_angkatan));
        }

        const mappedData = filtered.map(m => ({
            nim: m.nim,
            nmmw: m.nama,
            pwdf: m.nim + '@demo'
        }));

        setTimeout(() => {
            document.getElementById("btn-cari").disabled = false;
            document.getElementById("loader").style.display = "none";
            document.getElementById("kontenTabel").style.display = "block";

            this.setState({
                listMahasiswa: mappedData,
                statusData: 200
            });
            ConfDtb();
        }, 500);
    }

    ProcessGenerate = () => {
        if (this.state.check_list != 0) {
            swal({
                title: "Yakin untuk di generate ?",
                text: "password akan diubah ke default password.",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((baikdiubah) => {
                if (baikdiubah) {
                    var btn = document.getElementById("btn-generate");
                    btn.disabled = true;
                    btn.innerHTML = 'generating password&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i>';

                    // Simulate API call
                    setTimeout(() => {
                        swal({
                            icon: "success",
                            title: "Demo Mode",
                            text: "Password berhasil di-generate (simulasi)",
                            timer: 2000,
                            buttons: false,
                        }).then(() => {
                            $('#genPass').DataTable().destroy();
                            this.SearchMahasiswa();
                        });
                        var btn = document.getElementById("btn-generate");
                        btn.disabled = false;
                        btn.innerHTML = 'Generate password';
                    }, 1000);
                }
            });
        } else {
            swal({
                icon: "info",
                title: "Tidak ada data terpilih",
                text: "pilih mahasiswa dahulu lalu generating password",
            });
        }
    }

    parserText = (val) => {
        var txt = document.createElement("textarea");
        txt.innerHTML = val;
        return txt.value;
    }

    componentDidMount = () => {
        this.getProdi();
        this.getAngkatan();
        this.getJalur();
        ConfDtb();
    }

    render() {
        return (
            <Fragment>

                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Generate Password
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row" id="smoothMain">
                    <div className="col-xl-12">
                        <div className="card card-custom mb-3 pr-3 pl-3">
                            <div className="card-body">
                                <form onSubmit={this.SearchMahasiswaClick}>
                                    <div className="row">
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Program studi :</label>
                                            <div id="loaderProdi" className="loaderInput">
                                                <p align="right">
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                </p>
                                            </div>
                                            <select className="form-control selectCust"
                                                id="prodi"
                                                name="prodi"
                                                onChange={this.InputChange}
                                                required
                                            >
                                                <option value="">- pilih -</option>
                                                {
                                                    this.state.listProdi.map((prodi, index) => {
                                                        return (
                                                            <option key={index} value={prodi.ijur}>
                                                                {prodi.nmjur}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Tahun angkatan :</label>
                                            <div id="loaderAngkatan" className="loaderInput">
                                                <p align="right">
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                </p>
                                            </div>
                                            <select className="form-control selectCust"
                                                id="angkatan"
                                                name="thn_angkatan"
                                                onChange={this.InputChange}
                                                required
                                            >
                                                <option value="">- pilih -</option>
                                                {
                                                    this.state.listAngkatan.map((angkatan, index) => {
                                                        return (
                                                            <option key={index} value={angkatan.idtj}>
                                                                {angkatan.ketj}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <label style={{ fontSize: '14px' }}>Jalur :</label>
                                            <div id="loaderJalur" className="loaderInput">
                                                <p align="right">
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                </p>
                                            </div>
                                            <select id="jalur" className="form-control selectCust"
                                                name="jalur"
                                                onChange={this.InputChange}
                                            >
                                                <option value="">- pilih -</option>
                                                {
                                                    this.state.listJalur.map((jalur, index) => {
                                                        return (
                                                            <option key={index} value={jalur.idjl}>
                                                                {jalur.nmjl}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2 mb-2">
                                            <p align="right">
                                                <button
                                                    id="btn-cari"
                                                    className="btn btn-success btn-md"
                                                    style={{ borderRadius: '5px', marginTop: '28.5px' }}
                                                    type="submit"
                                                >
                                                    cari mahasiswa
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card card-custom">
                            <div className="card-body">
                                <p className="card-title text-center mb-3" style={{ fontSize: '25px', marginTop: '10px' }}>Generate Password</p>

                                <div id="loader" style={{ display: 'none', marginTop: '80px' }}>
                                    <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                        <div className="dot" />
                                        <div className="dot" />
                                        <div className="dot" />
                                    </div>
                                </div>

                                <div id="kontenTabel">
                                    <div className="table-responsive">
                                        <table id="genPass" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>Nama mahasiswa</th>
                                                    <th>NIM/Username</th>
                                                    <th>Default Password</th>
                                                    <th>
                                                        <div style={{ display: 'flex' }}>
                                                            &nbsp;<input type="checkbox" onChange={this.toggleCheckboxAll} value="" />&nbsp;&nbsp;<span style={{ marginTop: '-3px' }}>Pilih</span>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.listMahasiswa.map((mhs, index) => {
                                                        return (
                                                            <tr className="dark" key={index}>
                                                                <td>{index + 1}</td>
                                                                <td  style={{ textTransform:'uppercase' }}>{this.parserText(mhs.nmmw)}</td>
                                                                <td>{mhs.nim}</td>
                                                                <td>{mhs.pwdf}</td>
                                                                <td>
                                                                    <input onChange={this.toggleCheckbox} type="checkbox" name="check_list" value={mhs.nim} />
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {
                                        this.state.listMahasiswa != 0 ?
                                            <p align="right">
                                                <button className="btn btn-warn mt-4"
                                                    style={{ color: 'white' }}
                                                    id="btn-generate"
                                                    onClick={this.ProcessGenerate}
                                                >
                                                    Generate password
                                                </button>
                                            </p> :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default GeneratePass;